export enum LogStatusModuleName {
  Project = 1,
  Customer = 2,
  Coworker = 3,
}
